const SITE_TITLE = 'BSI-NI Brain Atlas';
const SITE_SLOGAN = 'Welcome to BRAIN ATLAS';
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-C186H597TK';
const XOONIPS_ITEMTYPES = ['files', 'url', 'paper', 'book'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

export type BrainAtlasType = 'degu' | 'jm' | 'marmoset';
export const BrainAtlasTypes: readonly BrainAtlasType[] = ['degu', 'jm', 'marmoset'];

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    BASE_URL,
};

export default Config;
